// ://httpsstackoverflow.com/questions/47219272/how-can-i-use-window-size-in-vue-how-do-i-detect-the-soft-keyboard

import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';

const LEFT_RIGHT_MARGIN = 5

function calculateIOSHeights() {

  const isPortrait = window.innerWidth <= window.innerHeight

  const statusBarHeight = (isPortrait) ? 44 : 0

  const properties = [ "--sab", "--sat", "--sal","--sar"]
  const pixels = []
  for (var i=0; i < 4; i++) {
    const propertyString = 
            getComputedStyle(document.documentElement).getPropertyValue(properties[i])
    //console.log("propertyString ",properties[i],propertyString)
    //var propertyNumber = parseFloat( propertyString.replace(/[^0-9]/g, ""))
    var propertyNumber = parseFloat( propertyString.replace(/[a-zA-Z]/g, ""))

    if (isNaN(propertyNumber))
      propertyNumber = 0
    //console.log("property number",propertyNumber)
    pixels.push(propertyNumber)
  }

  // console.log("is portrait",isPortrait)
  // console.log("pixels zero ",pixels[0])
  // console.log("pixels one ",pixels[1])

  const leftIndent = pixels[2]
  const topIndent = pixels[0] 
  const safeAreaString = pixels.join(",")
  //console.log("**** SafeArea ",safeAreaString)
  //alert("**** SAFE STRING " + safeAreaString)

  const heights = { top : topIndent, bottom : 65, left : leftIndent}
  return (heights)
}

export const getScreenSize = () => {
  return { width : window.innerWidth, height : window.innerHeight}
}

export const getTextWidth = (text, fontName, fontSizeInPixels) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = fontSizeInPixels + "px " + fontName

  //context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width;
}

export const availableWidthHeight = () => {
  const windowSizeStore = useWindowSizeStore()
  const osName = windowSizeStore.getOSName

  const connectionStore = useConnectionStore()

  //calculateIOSHeights()
  const deviceType = connectionStore.getDeviceType

  // console.log("******************* Device type ",deviceType)
  
  var bottomToolbarHeight = 50
  var topMenuHeight = 56
  var leftIndent = 0
  var topIndent = 0

  if (deviceType == "ios") {
    const heights = calculateIOSHeights()
    // bottomToolbarHeight = heights.bottom
    // topMenuHeight = heights.top
    leftIndent = heights.left
    topIndent = heights.top
    //console.log("topbar topmenu leftindent",bottomToolbarHeight,topMenuHeight,leftIndent)
    //console.log("window height width",window.innerHeight,window.innerWidth)

  }

  connectionStore.setToolbarHeight(bottomToolbarHeight)

  // FORCE THESE FOR IONIC
  //var bottomToolbarHeight = 50
  //var topMenuHeight = 56

  //console.log("in available  os name",osName)
  switch (deviceType) {
    case "ios" :
      //topMenuHeight = 106
      //bottomToolbarHeight = 65
      break
    case "android" :
      // only indent on landscape for camera space
      if (!(window.innerWidth <= window.innerHeight))
        leftIndent = 56
      break
    case "mobile" :
      // if (bottomToolbarHeight < 50)
      //   bottomToolbarHeight = 50
      //if (topMenuHeight > 0 && topMenuHeight < 50)
      //  topMenuHeight = 50
      //topMenuHeight = 96
      break
  }
 
  // for Chessvis and not Verbal Chess
  // const whichMenu = localStorage.getItem("whichMenu")
  // const showBigButtons = whichMenu == "buttons" || connectionStore.getShowBigButtons
  //const useBottomToolbarHeight = (!showBigButtons) ? bottomToolbarHeight : Math.floor(bottomToolbarHeight * connectionStore.getToolbarScalePercentage / 100.0)

  // VERBAL doesn't scale toolbar
  const useBottomToolbarHeight = bottomToolbarHeight

  return { width : window.innerWidth - LEFT_RIGHT_MARGIN * 2 - leftIndent, 
    height : window.innerHeight - topIndent - useBottomToolbarHeight,
    leftRightIndent : LEFT_RIGHT_MARGIN,
    leftIndent : leftIndent,
    topIndent : topIndent }
}

export const isScreenPortraitOrientation = (availableSpace) => {
  const isPortrait = (availableSpace.height * 1.5 >= availableSpace.width)
  return (isPortrait)
}

export const calculateChessBoardRect = (availableSpace,maxFractionOfScreen, leaveRoomForExtraPieces) => {
  const isPortrait = (availableSpace.hasOwnProperty("isPortrait")) ?
              availableSpace.isPortrait :

             (availableSpace.height * 1.5 >= availableSpace.width)

  var rectX = 0;
  var rectY = 0;
  var rectWidth = availableSpace.width;
  var rectHeight =  availableSpace.height;

  var chessBoardSquareSize = (isPortrait) ? availableSpace.width / 8 :
                    availableSpace.height / 8;

  // limit height or width to some fraction of screen
  if (maxFractionOfScreen > 0) {
    if (isPortrait) {
      if (chessBoardSquareSize * 8 > availableSpace.height * maxFractionOfScreen)
        chessBoardSquareSize = (availableSpace.height * maxFractionOfScreen) / 8;
    }
    else {
      //console.log("square size before",chessBoardSquareSize,availableSpace.width,maxFractionOfScreen)
      if (chessBoardSquareSize * 8 > availableSpace.width * maxFractionOfScreen)
        chessBoardSquareSize = (availableSpace.width * maxFractionOfScreen) / 8;
    }
  
    chessBoardSquareSize = Math.floor(chessBoardSquareSize)

    // center board & add space for side pieces if present

    if (isPortrait) {
      rectX = (availableSpace.width - chessBoardSquareSize * 8) / 2;
      rectWidth = chessBoardSquareSize * 8;
      rectHeight = chessBoardSquareSize * 8;
    }
    else {
      //rectY += (availableSpace.height - chessBoardSquareSize * 8) / 2;
      rectHeight = chessBoardSquareSize * 8;
      rectWidth = chessBoardSquareSize * 8;
    }
  }
  //console.log("board size rect  width/height ",rectWidth,rectHeight)
  return ( {
    x : rectX,
    y : rectY,
    height : rectHeight,
    width : rectWidth,
    isPortrait : isPortrait
  })
}

export const scrollElement = (id,direction) => {
  //console.log("in scroll element",id,direction)
  const element = document.getElementById(id)
  if (element == null) {
    //console.log("**** no element to scroll",id)
    return

  }
  const divHeight = element.offsetHeight;
  var scrollTop = element.scrollTop
  //console.log("height of div and current top",divHeight,scrollTop,element)
  switch (direction) {
    case "down" :
      scrollTop += divHeight
      break
    case "up" :
      scrollTop -= divHeight
      if (scrollTop < 0)
        scrollTop = 0
      break
    case "top" :
      scrollTop = 0
      break
  }
  //console.log("new top",scrollTop)
  element.scrollTo(0,scrollTop)
}

export const buildStyleToolbar = (availableSpace) => {
  const top = availableSpace.topIndent + availableSpace.height
  const height = 50
  const styleToolbar = {
    position : "absolute",
    top : top + "px",
    left : availableSpace.leftIndent + "px",
    width: window.innerWidth + "px",
    height : height + "px"
  }
  return (styleToolbar)
}

export const buildStyleTopline = (availableSpace) => {
  const top = availableSpace.topIndent
  const height = 56
  const styleTopline = {
    position : "absolute",
    top : top + "px",
    left : availableSpace.leftIndent + "px",
    width: window.innerWidth + "px",
    height : height + "px"
  }
  return (styleTopline)
}

export const buildStyleMiddle = (availableSpace) => {
  const topline = 56 + availableSpace.topIndent
  const toolbar = 50
  const height =  window.innerHeight  - topline - toolbar -1
  const styleMiddle = {
    position : "absolute",
    "overflow-y" : "scroll",
    top : topline + "px",
    left : availableSpace.leftIndent + "px",
    width: availableSpace.width + "px",
    height : height + "px"
  }
  return (styleMiddle)
}

export const buildStyleMiddleNoToolbar = (availableSpace) => {
  const topline = 56 + availableSpace.topIndent
  const height =  window.innerHeight  - topline -1
  const styleMiddle = {
    position : "absolute",
    "overflow-y" : "scroll",
    top : topline + "px",
    left : "0px",
    width: availableSpace.width + "px",
    height : height + "px"
  }
  return (styleMiddle)
}

export const buildStyleFullScreen = () => {
  const height =  window.innerHeight
  const width = window.innerWidth
  const styleMiddle = {
    position : "absolute",
    "overflow-y" : "scroll",
    top :  "0px",
    left : "0px",
    width: width + "px",
    height : height + "px"
  }
  return (styleMiddle)
}

export const middleRect = (availableSpace) => {
  const topline = 56 + availableSpace.topIndent
  const toolbar = 50
  const height =  window.innerHeight  - topline - toolbar -1
  const rect = { top : topline , left : 0, width : availableSpace.width, 
                height : height }
  return (rect)
}

